import React from "react";
import CabPage from "./CabPage";
import "./css/settings.css";

/** Sidebar sections that exist in the wireframes but have no backend yet. */
export default function ComingSoonPage({ title }) {
  return (
    <CabPage name="settings">
      <main id="main">
        <section className="intro">
          <h1>{title}</h1>
          <p>Раздел в разработке — появится в одной из следующих версий.</p>
        </section>
      </main>
    </CabPage>
  );
}
